import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { BaseDataSource, QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KhoDeNghiXuatKhoService } from '../kho-de-nghi-xuat-kho-service/kho-de-nghi-xuat-kho.service';

export class KhoDeNghiXuatKhoDataSource extends BaseDataSource {
	constructor(private productsService: KhoDeNghiXuatKhoService) {
		super();
	}
	loadKhoDeNghiXuatKhos(queryParams: QueryParamsModel) {
		this.productsService.lastFilter$.next(queryParams);
		this.productsService.lastFilterDN$.next(queryParams);
        this.loadingSubject.next(true);
		this.productsService.getData(queryParams)
			.pipe(
				tap(resultFromServer => {
					if (resultFromServer.data != null && resultFromServer.data != undefined) {
						this.entitySubject.next(resultFromServer.data);
						this.paginatorTotalSubject.next(resultFromServer.page.TotalCount);
					}
					else {
						this.entitySubject.next(null);
						this.paginatorTotalSubject.next(null);
					}
				}),
				catchError(err => of(new QueryResultsModel([], err))),
				finalize(() => this.loadingSubject.next(false))
			).subscribe();
	}

	loadChiTietSoLuongTon(queryParams: QueryParamsModel) {
		this.productsService.lastFilter$.next(queryParams);
		this.productsService.lastFilterDN$.next(queryParams);
        this.loadingSubject.next(true);
		this.productsService.getDataSLTon(queryParams)
			.pipe(
				tap(resultFromServer => {
					if (resultFromServer.data != null && resultFromServer.data != undefined) {
						this.entitySubject.next(resultFromServer.data);
						this.paginatorTotalSubject.next(resultFromServer.page.TotalCount);
					}
					else {
						this.entitySubject.next(null);
						this.paginatorTotalSubject.next(null);
					}
				}),
				catchError(err => of(new QueryResultsModel([], err))),
				finalize(() => this.loadingSubject.next(false))
			).subscribe();
	}


}
